module.exports = __webpack_public_path__ + "img/qgjj-06.prt.0ecde284.jpg";